app-home-page-country-dialog mat-list{max-height:270px;overflow:auto}app-home-page-country-dialog mat-list mat-list-item{border-bottom:1px solid rgba(0,0,0,.1);height:48px!important;font-size:1rem}
/*# sourceMappingURL=home-page-country-dialog.component-LG76G62G.css.map */
